import React, { useEffect, useState, useMemo } from 'react'
import { Wrapper, BarStrip,  StepperItem, ProgressBar, Modal, TextAreaIcon, TextFieldIcon, FileFieldIcon } from '../_components'
import Table, { SelectColumnFilter } from '../_components/Table'
import data from '../fixtures'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { setDisplayVerify } from '../_slices/AppSlice' 
import Axios from 'axios'
import moment from 'moment'
import { FaAddressCard } from 'react-icons/fa'

const steps = [
  "Pending",
  "Actioned"
]

const VerifyField = record => {

  const handleClick = async id => {
    await localStorage.setItem( "applicationId", id )
    await localStorage.setItem( "link", "display")
    window.location.reload()
  }

  const handleManualPayment = async id => {
    await localStorage.setItem( "applicationId", id )
    await localStorage.setItem( "link", "action_manual_payment")
    window.location.reload()
  }

  if((parseInt( record.row.original.stage ) === 3) &&  (record.row.original.verify_status?.toLowerCase() === "completed" && record.row.original.prn !== null && record.row.original.prn_status !== 'C')){
    // manual payments
    return (
    <div onClick={() => handleManualPayment( record.value )} className="uppercase cursor-pointer bg-blue-500 text-xs text-center px-2 py-1 rounded text-white">
      {`Clear Payment`}
    </div> )
  } else{
    // set fee for applicant to pay
    return (
      (record.row.original.verification_status?.toLowerCase() !== "completed" && record.row.original.prn === null) && 
      (<div onClick={() => handleClick( record.value )} className="uppercase cursor-pointer bg-green-700 text-xs text-center px-2 py-1 rounded text-white">
        {`Set certification fee`}
      </div> )
    )
  }
}

export default function AllFinance( ) {

  const ApplicationColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Registered Name of ITSP",
      accessor: "applicant"
    },
    {
      Header: "Date Applied",
      accessor: "date"
    },
    {
        Header: "Date Updated",
        accessor: "date_updated"
    },
    {
        Header: "Contact Person",
        accessor: "contact_person"
    },
    {
        Header: "Mobile No",
        accessor: "phone_number"
    },
    {
        Header: "Fees to Pay",
        accessor: "certification_fees_to_pay",
    },
    {
        Header: "Actions",
        accessor: "id",
        Cell: VerifyField
    }
  ] )


  const ActionedColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Registered Name of ITSP",
      accessor: "applicant"
    },
    {
      Header: "Date Applied",
      accessor: "date"
    },
    {
      Header: "Date Updated",
      accessor: "date_updated"
    },
    {
      Header: "Contact Person",
      accessor: "contact_person"
    },
    {
      Header: "Mobile No",
      accessor: "phone_number"
    },
    {
      Header: "Fees to Pay",
      accessor: "certification_fees_to_pay",
    },
    {
        Header: "Actions",
        accessor: "id",
        Cell: VerifyField
    }
  ] )

  const dispatch = useDispatch()
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ showModal, setShowModal ] = useState( false )
  const [ tag, setTag ] = useState( "Pending" )
  const state = useSelector( state => {
    return {
      id: state.application.verifyModal?.id,
      displayModal: state.application.verifyModal?.display,
      record: state.application.verifyModal?.record,
    }
  } )

  useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const handleResults = ( values ) => {
    switch( localStorage.getItem( "role" )?.toUpperCase() ){
      case "VERIFIER":
        return values.filter( item => {
          if( tag?.toLowerCase() === "pending" ) {
            return parseInt( item.stage ) === 1
          }
          if( tag?.toLowerCase() === "actioned" ) {
            return parseInt( item.stage ) > 1
          }
        } )
      case "AUDITOR":
        return values.filter( item => parseInt( item.stage ) === 3  )
      case "FINANCE":
        if(localStorage.getItem( "link" )?.toLowerCase() === "non_ura_payments"){
          return values.filter( item => (parseInt( item.stage ) === 3) &&  (item.verify_status?.toLowerCase() === "completed" && item.prn !== null && item.prn_status !== "C"))
        } else{
          return values.filter( item => (parseInt( item.stage ) === 2 && item.prn === null) )
        }
      default:
        return
    }
  }

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
        const results = response.data.map( ( result, index ) => {
          return {
            recordId: `${index+1}`,
            sno: result.serial_number,
            progress: result.progress,
            applicant: result.trading_name,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ), 
            date_updated: moment( result.updated_at ).format( "DD MMM, YYYY" ),
            contact_person: `${result.contact_first_name || ""} ${result.contact_last_name || ""}`,
            designation: result.designation,
            email_id: result.created_by,
            phone_number: result.contact_phone_number,
            verify_status: result.verification_status || "Pending",
            updated_at: result.updated_at,
            id: result.id,
            report: "",
            stage: result.stage,
            progress: result.progress,
            prn: result.payment_reference_number,
            prn_status: result.prn_status,
            certification_fees_to_pay: result.certification_fees_to_pay
          }
        }).sort( ( a, b ) => {
          return moment( b.updated_at ).format( "YYYYMMDDHHMM" ) - moment( a.updated_at ).format( "YYYYMMDDHHMM" )
        })
        setRecords( results )
        setLoading( false )
      }
    } catch (error) {
      console.log("failed to fetch applications for finance")
      alert( "Server error occurred." )
      setLoading( false )
    }
  }

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip title={`Applications for finance to review`} />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`Generate Invoices for Audited Applicants`}
            </div>

            <div className="flex flex-col items-start justify-center w-full bg-white">
              <div className="flex flex-row border-b border-gray-500 rounded-sm">
                {/* tabs */}
                {steps.map( ( item, index ) => {
                  return (
                  <StepperItem 
                    edge={index === 0} 
                    active={tag.toUpperCase() === item?.toUpperCase()} 
                    key={item} 
                    label={item} 
                    onPress={() => {
                      return setTag( item )
                    } } />
                  )
                } )}
              </div>
              <Table 
                label="Application Details"
                columns={tag === "Pending" ? ApplicationColumns : ActionedColumns}
                data={handleResults( records )}
                hidePagination={false}
              />
            </div>

          </div>
        </div>
    </Wrapper>
  )
}
